import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import styled from "styled-components";
import BG from "assets/images/jpgs/bg.jpg";
import ChildWater from "assets/images/jpgs/ChildWater.jpg";
import LadySmiling from "assets/images/jpgs/LadySmiling.jpg";
import { TKIconNativeEllipse } from "assets/images/svgs";
import { Link } from "react-router-dom";

const Banner = () => {
  const imageData = [
    {
      label: "Image 1",
      alt: "image1",
      url: BG,
      text: "Be the hands of love to those in need",
    },
    {
      label: "Image 2",
      alt: "image2",
      url: LadySmiling,
      text: "Transforming Lives, one project at a time",
    },
    {
      label: "Image 3",
      alt: "image3",
      url: ChildWater,
      text: "Join the movement of change",
    },
  ];

  return (
    <div className="mt-20">
      <CarouselWrapper>
        <div className="absolute top-0 right-2 z-10">
          <div className="flex flex-col items-center gap-2">
            <div className="bg-white w-[2px] h-[110px]"></div>
            <TKIconNativeEllipse />
          </div>
        </div>
        <Carousel
          showArrows={true}
          autoPlay={true}
          infiniteLoop={true}
          useKeyboardArrows={true}
          renderArrowPrev={() => {
            return null;
          }}
          showThumbs={false}
        >
          {imageData.map((slider, index) => (
            <ImgContainer key={index}>
              <CarouselImg src={slider.url} alt={slider.alt} />
              <BannerTextWrapper>
                <h1>{slider.text}</h1>
                <p>Check our latest projects or Causes </p>
                <DonateBtn>
                  <Link to="/projects">GET STARTED</Link>
                </DonateBtn>
              </BannerTextWrapper>
            </ImgContainer>
          ))}
        </Carousel>
        {
          //   <NextButton onClick={handleNextIndex}>
          //   <TKIconCircleArrowLeft />
          // </NextButton>
        }
      </CarouselWrapper>
      <Divider className="w-full h-[8px]"></Divider>
    </div>
  );
};

export default Banner;

const CarouselWrapper = styled.div`
  position: relative;

  .carousel-status {
    display: none;
  }
`;
const ImgContainer = styled.div`
  position: relative;
  height: calc(600px);
  width: 100vw;
`;
const CarouselImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const BannerTextWrapper = styled.div`
  width: 40%;
  color: white;
  position: absolute;
  bottom: 40%;
  left: 5%;
  right: 5%;
  text-align: start;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media screen and (max-width: 700px) {
    width: 80%;
  }

  h1 {
    font-weight: 800;
    font-size: 36px;
    line-height: 42px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }
  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }
`;
const DonateBtn = styled.p`
  width: fit-content;
  white-space: nowrap;
  background: url(${BG}), linear-gradient(to right, #f57200, #f0ca18);
  background-position: 10% 40%;
  background-repeat: no-repeat;
  border-radius: 50px;
  border: 2px solid #f57200;
  padding: 0.5rem 0.8rem;

  :hover {
    cursor: pointer;
    font-weight: 700;
  }
`;
const Divider = styled.div`
  background: linear-gradient(270deg, #f57200 -94.44%, #f0ca18 108.89%);
`;
